import {THEME_ENUM} from 'constants/theme.constant';

/**
 * Since some configurations need to be match with specific themes,
 * we recommend to use the configuration that generated from demo.
 */
/**
 * 
 * 
 * 
 * {
  "themeColor": "cyan",
  "direction": "ltr",
  "mode": "dark",
  "primaryColorLevel": 800,
  "cardBordered": false,
  "panelExpand": false,
  "controlSize": "md",
  "navMode": "themed",
  "layout": {
    "type": "classic",
    "sideNavCollapse": false
  }
}
 */
export const themeConfig = (() => {
  switch (window.location.hostname) {
    case 'facturacion.uat.it-arkon.com.mx':
      // Configuración para el entorno de desarrollo
      return {
        themeColor: 'sky',
        direction: 'ltr',
        mode: 'dark',
        locale: 'en',
        primaryColorLevel: 600,
        cardBordered: false,
        panelExpand: false,
        controlSize: 'md',
        navMode: 'themed', // light, dark, themed
        layout: {
          type: 'classic',
          sideNavCollapse: false
        }
      };
    case 'facturacion.it-arkon.com.mx':
      // Configuración para el entorno de desarrollo
      return {
        themeColor: 'violet',
        direction: 'ltr',
        mode: 'dark',
        locale: 'en',
        primaryColorLevel: 900,
        cardBordered: false,
        panelExpand: false,
        controlSize: 'md',
        navMode: 'themed', // light, dark, themed
        layout: {
          type: 'classic',
          sideNavCollapse: false
        }
      };

    case 'localhost':
      // Configuración para el entorno de desarrollo
      return {
        themeColor: 'cyan',
        direction: 'ltr',
        mode: 'dark',
        locale: 'en',
        primaryColorLevel: 900,
        cardBordered: false,
        panelExpand: false,
        controlSize: 'md',
        navMode: 'themed', // light, dark, themed
        layout: {
          type: 'classic',
          sideNavCollapse: false
        }
      };

    default:
      // Configuración por defecto
      return {
        themeColor: 'teal',
        direction: 'ltr',
        mode: 'light',
        locale: 'en',
        primaryColorLevel: 900,
        cardBordered: false,
        panelExpand: false,
        controlSize: 'md',
        navMode: 'themed', // light, dark, themed
        layout: {
          type: 'classic',
          sideNavCollapse: false
        }
      };
  }
})();
